import React, { useEffect } from 'react';

function CertificatePage({ onBack }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="certificate-page">
      {/* Top Navigation Bar */}
      <div className="certificate-top-bar">
        <div className="certificate-back-btn" onClick={onBack}>
          <i className="bi bi-chevron-left"></i>
        </div>
        <div className="certificate-title-text">Certificate</div>
        <div className="certificate-spacer"></div>
      </div>

      {/* Content Area */}
      <div className="certificate-content">
        <div className="certificate-image-container">
          <img 
            src="/certificate/certificate.jpg" 
            alt="Certificate" 
            className="certificate-image"
            onError={(e) => {
              // Fallback if image doesn't exist
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <div className="certificate-placeholder" style={{ display: 'none' }}>
            <i className="bi bi-award certificate-placeholder-icon"></i>
            <p className="certificate-placeholder-text">Certificate Image</p>
            <p className="certificate-placeholder-hint">Place your certificate image at /public/certificate/certificate.png</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CertificatePage;

